import { AppActionTypes } from "@app/store/actions/app.actions";
import { PayloadActionInterface } from "@app/store/actions/payload-action.interface";
import { GroupInterface } from "@core/interfaces/group.interface";
import { GetGroupsParamsInterface } from "@core/services/api/classic/groups/group-api.service";

export class LoadGroups implements PayloadActionInterface {
  readonly type = AppActionTypes.LOAD_GROUPS;

  constructor(public payload: { params: GetGroupsParamsInterface }) {}
}

export class LoadGroupsSuccess implements PayloadActionInterface {
  readonly type = AppActionTypes.LOAD_GROUPS_SUCCESS;

  constructor(
    public payload: {
      params: GetGroupsParamsInterface;
      groups: GroupInterface[];
    }
  ) {}
}

export class LoadGroupsFailure implements PayloadActionInterface {
  readonly type = AppActionTypes.LOAD_GROUPS_FAILURE;

  constructor(
    public payload: {
      params: GetGroupsParamsInterface;
      error: any;
    }
  ) {}
}

export class JoinGroup implements PayloadActionInterface {
  readonly type = AppActionTypes.JOIN_GROUP;

  constructor(public payload: { groupId: number }) {}
}

export class JoinGroupSuccess implements PayloadActionInterface {
  readonly type = AppActionTypes.JOIN_GROUP_SUCCESS;

  constructor(public payload: { group: GroupInterface }) {}
}

export class JoinGroupFailure implements PayloadActionInterface {
  readonly type = AppActionTypes.JOIN_GROUP_FAILURE;

  constructor(public payload: { error: any }) {}
}

export class LeaveGroup implements PayloadActionInterface {
  readonly type = AppActionTypes.LEAVE_GROUP;

  constructor(public payload: { groupId: number }) {}
}

export class LeaveGroupSuccess implements PayloadActionInterface {
  readonly type = AppActionTypes.LEAVE_GROUP_SUCCESS;

  constructor(public payload: { groupId: number }) {}
}

export class LeaveGroupFailure implements PayloadActionInterface {
  readonly type = AppActionTypes.LEAVE_GROUP_FAILURE;

  constructor(public payload: { error: any }) {}
}
